import styles from './Spinner.module.scss'

export default class Spinner extends React.PureComponent {
  static propTypes = {
    size: PropTypes.oneOf(['small', 'normal']),
  }

  render() {
    const {
      className,
      ...passedProps
    } = this.props
    return (
      <div className={cx(className, styles.root)} {...passedProps} />
    )
  }
}
